import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import template from './paletteDialog.jsx';
import displayNames from '../displayNames';

var PaletteDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(PaletteDialog, _React$Component);

  var _super = _createSuper(PaletteDialog);

  function PaletteDialog(props) {
    var _this;

    _classCallCheck(this, PaletteDialog);

    _this = _super.call(this, props);
    _this.initialPalette = _this.props.palette;

    var revertToInitial = function revertToInitial() {
      return _this.props.onPaletteChange(_this.initialPalette);
    };

    _this.onBackToPreset = function () {
      revertToInitial();

      _this.props.toggleChangeMode();
    };

    _this.onCancel = function () {
      revertToInitial();

      if (_.isFunction(_this.props.onClose)) {
        _this.props.onClose();
      }
    };

    return _this;
  }

  _createClass(PaletteDialog, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return PaletteDialog;
}(React.Component);

PaletteDialog.displayName = displayNames.PALETTE_DIALOG;
PaletteDialog.propTypes = {
  textKeys: PropTypes.objectOf(PropTypes.string),
  onHelp: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  addColor: PropTypes.func.isRequired,
  toggleChangeMode: PropTypes.func.isRequired,
  myColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  changeMode: PropTypes.bool,
  chooseColor: PropTypes.func,
  onPreviewChange: PropTypes.func,
  onPaletteChange: PropTypes.func,
  colorSelectedIndex: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  mainColors: PropTypes.arrayOf(PropTypes.string)
};
PaletteDialog.defaultProps = {
  textKeys: {}
};
export default compose(PaletteDialog);